var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('combobox-base',{attrs:{"query":_vm.query,"itemsGetter":_vm.itemsGetter,"value":_vm.value,"label":"Jazyk"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }